<template>
    <CRow>
        <CCol>
            <CCard>
                <CCardHeader>
                    <strong>Настройка реферальной программы</strong>
                </CCardHeader>
                <CCardBody>
                    <CRow class="pl-3 pb-3" />
                    <CForm>
                        <CRow>
                            <CCol
                                tag="label"
                                sm="3"
                                class="col-form-label">
                                Активен
                            </CCol>
                            <CCol sm="9">
                                <CSwitch
                                    :checked.sync="referal_program.enabled"
                                    color="success"
                                    shape="pill"
                                    variant="opposite"/>
                            </CCol>
                        </CRow>
                        <CInput
                            v-model="referal_program.main_text"
                            label="Основной текст"/>
                        <CInput
                            v-model="referal_program.description_text"
                            label="Описание"/>
                        <CInput 
                            v-model="referal_program.share_text"
                            label="Текст при шеринге"/>
                        <CRow v-if="referal_program.picture">
                            <CCol sm="3" class="col-form-label">&nbsp;</CCol>
                            <CCol sm="9" class="col-form-label">
                                <CImg
                                    :src="referalProgramPictureUrl"
                                    class="m2"
                                    width="200" />
                            </CCol>
                        </CRow>
                        <CInputFile
                            ref="picture"
                            label="Изображение"
                            horizontal
                            @change="selectReferalProgramPicture" />
                        <CRow>
                            <CCol
                                tag="label"
                                sm="3"
                                class="col-form-label">Активный промокод</CCol>
                            <CCol
                                sm="9"
                                class="col-form-label"
                                v-if="referal_program.active_promocode_id && promocode">
                                <CLink 
                                    :to="{ path: `/promocodes/${referal_program.active_promocode_id}` }"> 
                                    {{ promocode.code }} 
                                </CLink>
                            </CCol>
                        </CRow>
                    </CForm>
                </CCardBody>
                <CCardFooter>
                    <CButton
                        color="primary"
                        class="mr-3"
                        @click="save"
                    >Сохранить</CButton>
                    <CButton
                        color="light"
                        class="mr-3"
                        @click="goBack"
                    >Отмена</CButton>
                </CCardFooter>
            </CCard>
        </CCol>
    </CRow>
</template>

<script>
    import Vue from 'vue';

    export default {
        name: 'ReferalProgramSettings',

        data() {
            return {
                referal_program: {
                    picture: '',
                    enabled: true,
                    main_text: '',
                    description_text: '',
                    share_text: '',
                    active_promocode_id: null,
                },
                promocode: null,
                selectedReferalProgramPicture: null,
            };  
        },

        computed: {
            referalProgramPictureUrl() {
                if (this.referal_program.picture) {
                    return process.env.VUE_APP_STATIC_BASE_URL + '/' + this.referal_program.picture;
                }
                return '';
            },
        },

        async mounted() {
            const data = (await Vue.axios.get('/referal-program')).data;
            if (data && data[0]?.id) {
                this.referal_program = data[0];
            }
            if (this.referal_program.active_promocode_id) {
                const promocode = (await Vue.axios.get(`/promocodes/${this.referal_program.active_promocode_id}`)).data;
                this.promocode = promocode;
            }
        },  

        methods: {
            async save() {
                try {
                    if (this.selectedReferalProgramPicture) {
                        let formData = new FormData();
                        formData.append('file', this.selectedReferalProgramPicture);
                        const pictureName = await Vue.axios.post('/files/upload', formData);
                        this.referal_program.picture = pictureName.data.filename;
                    }
                    await Vue.axios.put('/referal-program', this.referal_program);
                    this.$router.go(0);
                } catch (e) {
                    this.$root.$emit('showError', 'Ошибка сохранения.')
                    console.log(e);
                }
            },
            selectReferalProgramPicture(FileList) {
                this.selectedReferalProgramPicture = FileList[0];
            },
            goBack() {
                this.$router.push({ path: '/dashboard' });
            },
        },
    };
</script>
